var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import icons from '../assets/icons';
/**
 * In order to add the new icon into the sprite
 * please add icons to common/assets/icons/index.ts
 */
var Icon = function (_a) {
    var name = _a.name, className = _a.className, dataTestId = _a.dataTestId, role = _a.role, title = _a.title, ariaHidden = _a.ariaHidden;
    var _b = icons[name], id = _b.id, viewBox = _b.viewBox;
    return (React.createElement("svg", __assign({ viewBox: viewBox, className: className, "data-testid": dataTestId, role: role }, (ariaHidden !== undefined && { 'aria-hidden': ariaHidden })),
        title && React.createElement("title", null, title),
        React.createElement("use", { href: "#" + id })));
};
Icon.defaultProps = {
    dataTestId: 'icon',
};
export default memo(Icon);
